module.exports = __webpack_public_path__ + "static/media/HumanistSlabserif712BT-Roman.b4b2f4ab.ttf";